export default __webpack_public_path__ + "static/media/bg05.1a591fcc.svg";